import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/components/SelectSourcePanel/SelectSourcePanel.styled.ts",
    _templateObject2,
    _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Button, ScrollBar } from '@gmini/ui-kit';
import styled from 'styled-components';
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n"])));
export var AddButton = styled(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: 24px;\n  width: fit-content;\n"]))); // eslint-disable-next-line @typescript-eslint/no-explicit-any

export var ScrollableSourceList = styled(ScrollBar)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  max-height: 400px;\n\n  && .simplebar-content > div {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n"])));